function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#check-round_svg__clip0_298_8774)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4.5 4.5h9.75v9.75H4.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 1.5C4.875 1.5 1.5 4.875 1.5 9s3.375 7.5 7.5 7.5 7.5-3.375 7.5-7.5S13.125 1.5 9 1.5zm3.525 5.775l-4.5 4.5c-.3.3-.75.3-1.05 0l-1.5-1.5c-.3-.3-.3-.75 0-1.05.3-.3.75-.3 1.05 0l.975.975 3.975-3.975c.3-.3.75-.3 1.05 0 .3.3.3.75 0 1.05z",
  fill: "#F58220"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "check-round_svg__clip0_298_8774"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h18v18H0z"
})));

function SvgCheckRound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgCheckRound;